import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import * as entity from '@boutique/entities'

import { useProductListing } from '../../hooks/useProductListing'
import { RangeInput } from './RangeInput'

type PriceFilterProps = {
  data: entity.search.product.Result | undefined
}

export function PriceFilter({ data }: PriceFilterProps): React.ReactElement {
  const [isOpen, setIsOpen] = React.useState(false)

  const { query, setPriceRange, apply } = useProductListing()

  const { range, boundary } = getValue()

  return (
    <>
      {boundary.min !== boundary.max && (
        <Accordion title="Prix" open={isOpen} onToggle={() => setIsOpen(!isOpen)}>
          <RangeInput
            value={range}
            boundary={boundary}
            onChange={(range) => {
              apply(setPriceRange(range), { scroll: false })
            }}
          />
        </Accordion>
      )}
    </>
  )

  function getValue() {
    const facet = data?.facets.price
    if (facet === undefined) {
      return { range: { start: 0, end: 0 }, boundary: { min: 0, max: 0 } }
    }

    return {
      range: {
        start: Math.max(query.priceRange?.start ?? facet.min, facet.min),
        end: Math.min(query.priceRange?.end ?? facet.max, facet.max),
      },
      boundary: { min: facet.min, max: facet.max },
    }
  }
}

const Accordion = styled(plume.Accordion)`
  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    padding: 22px 14px 18px;
  }
`
